import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { DetailPageLayout } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useFilterStorage } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';
import { useVerifierParamId } from 'src/hooks/verifier';
import { useCheckVerifierAdmins } from 'src/hooks/verifier/useCheckVerifierAdmins';
import { useVerifierStaffList } from 'src/hooks/verifierStaff';
import { ResendInviteModal } from 'src/modals/invite';

import { VerifierStaffTableClearVerifyAdmin } from './VerifierStaffTableClearVerifyAdmin';

// TODO: rename to ...ClearVerifyStaff
export const VerifierStaffWrapperClearVerifyAdmin: React.FC = () => {
  const { openModal } = useModal();
  const { pagination } = useFilterStorage();

  const verifierId = useVerifierParamId();
  const {
    verifierStaffList,
    verifierStaffCount,
    loading: loadingVerifierStaffList,
    refetch: refetchVerifierStaffList,
  } = useVerifierStaffList(verifierId, undefined, true);

  const {
    isDisabled,
    loading: loadingCheckVerifierAdmins,
    refetch: refetchCheckVerifierAdmins,
  } = useCheckVerifierAdmins(verifierId);

  const refetchData = React.useCallback(async () => {
    await refetchVerifierStaffList();
    await refetchCheckVerifierAdmins();
    pagination.resetPage();
  }, [pagination, refetchVerifierStaffList, refetchCheckVerifierAdmins]);

  const handleInvite = React.useCallback(() => {
    openModal(ModalId.InviteVerifiersStaffByCVAdmin, { verifierId, isDisabled });
  }, [openModal, verifierId, isDisabled]);

  return (
    <React.Fragment>
      <DetailPageLayout
        titleContent="Staff"
        topRightContent={
          <Button
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={handleInvite}
            // the modal snapshots isDisabled on open — clicking before the admins check has
            // answered opens the form with the admin checkbox wrongly enabled
            disabled={loadingCheckVerifierAdmins}
          >
            New
          </Button>
        }
      >
        <VerifierStaffTableClearVerifyAdmin
          verifierStaffList={verifierStaffList}
          verifierStaffCount={verifierStaffCount}
          pagination={pagination}
          onRefresh={refetchData}
          loading={loadingVerifierStaffList || loadingCheckVerifierAdmins}
        />
      </DetailPageLayout>

      <ResendInviteModal />
    </React.Fragment>
  );
};
